import { motion } from "framer-motion";
import { useI18n } from "@/lib/i18n";

export default function Manifesto() {
  const { t } = useI18n();
  return (
    <section id="manifesto" className="relative py-24 md:py-32 bg-[#0a0a0a]" data-testid="manifesto-section">
      <div className="mx-auto max-w-[1440px] px-6 md:px-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.7 }}
          className="grid md:grid-cols-12 gap-8 mb-16 md:mb-24"
        >
          <div className="md:col-span-4">
            <div className="flex items-center gap-3 font-mono-acc text-[11px] tracking-[0.25em] uppercase text-[#A1A1AA]">
              <span className="w-8 h-px bg-[#E1FF00]" />
              {t.manifesto.overline}
            </div>
          </div>
          <div className="md:col-span-8">
            <h2 className="font-display text-5xl md:text-6xl lg:text-7xl text-[#F4F4F5] tracking-tighter leading-[0.95]">
              {t.manifesto.title}
            </h2>
          </div>
        </motion.div>

        <div className="border-t border-[#27272A]">
          {t.manifesto.chapters.map((ch, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.6, delay: i * 0.08 }}
              className="grid md:grid-cols-12 gap-8 py-10 md:py-14 border-b border-[#27272A] group hover:bg-[#050505] transition-colors"
              data-testid={`chapter-${ch.num}`}
            >
              <div className="md:col-span-2 font-mono-acc text-sm tracking-widest text-[#E1FF00]">
                {ch.num}
              </div>
              <div className="md:col-span-4">
                <h3 className="font-display text-3xl md:text-4xl text-[#F4F4F5] tracking-tight">
                  {ch.title}
                </h3>
              </div>
              <div className="md:col-span-6">
                <p className="text-[#A1A1AA] text-base md:text-lg leading-relaxed">
                  {ch.body}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
